
import developer from './developer'//开发者管理
import accountBind from './accountBind'//厂商账号绑定
export default [
  ...developer,
	...accountBind,
]